import store from "@/state/store";

const isSaml = process.env.VUE_APP_IS_USE_SAML_AUTH === 'true';

let routes;

if (isSaml) {
  // GMO トラストログインによる SAML 認証を使用
  routes = [
    {
      path: '/login',
      name: 'login',
      beforeEnter() {
        window.location = process.env.VUE_APP_SAML_LOGIN_URL
      },
      meta: () => {},
    },
    {
      path: '/sso/callback',
      name: 'ssoCallback',
      component: () => import('../views/pages/account/sso-callback'),
      meta: () => {},
    }
  ];
} else {
  // システム内のログイン画面を使用
  routes = [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/pages/account/login'),
      meta: () => {},
    },
  ];
}

export const routes_auth = routes;
